const html = document.querySelector('html');
const modalButtonArray = [...document.querySelectorAll('.js-modal')];
const modalContetnArray = [...document.querySelectorAll('.js-modal-content')];
const modalCloseButtonTop = [...document.querySelectorAll('.p-banquet-close.top')];
const modalCloseButtonUnder = [...document.querySelectorAll('.p-banquet-close.under')];
const overlay = document.querySelector('.p-banquet-modal-overlay');

modalButtonArray.forEach((button, index) => {
  button.addEventListener('click', () => {
    modalContetnArray[index].classList.add('is-open');
    overlay.classList.add('is-open');
    html.classList.add('u-hidden');
  })
})

modalCloseButtonTop.forEach((button, index) => {
  button.addEventListener('click', () => {
    modalContetnArray[index].classList.remove('is-open');
    overlay.classList.remove('is-open');
    html.classList.remove('u-hidden');
  })
})

modalCloseButtonUnder.forEach((button, index) => {
  button.addEventListener('click', () => {
    modalContetnArray[index].classList.remove('is-open');
    overlay.classList.remove('is-open');
    html.classList.remove('u-hidden');
  })
})


if(overlay) {
  overlay.addEventListener('click', () => {
    modalContetnArray.forEach((e) => {
      if(e.classList.contains('is-open')) {
        e.classList.remove('is-open');
      }
    })
    overlay.classList.remove('is-open');
    html.classList.remove('u-hidden');
  })
}
